import { MenuProps } from "antd";
import { PropertyListQueryParams } from "../types";

export const dummyRequest = (response) => {
  // console.log("check response", response);
  setTimeout(() => {
    response.onSuccess("ok");
  }, 0);
};

export const uniq = (val) => {
  const seen = new Set();
  return val.filter((el) => {
    const duplicate = seen.has(el.labelName);
    seen.add(el.labelName);
    return !duplicate;
  });
};

export const getMenuItems = (): MenuProps["items"] => {
  try {
    const userDataString = localStorage.getItem("login-response");
    if (!userDataString) return []; // No data found

    const { usertype } = JSON.parse(userDataString) || {};
    const isInstitutionalLandlord = Array.isArray(usertype) && usertype.includes("institutionalLandlord");

    const baseItems = [
      { label: "Property", key: 0 },
      { label: "Parkings", key: 1 },
      { label: "Update Approved Rent", key: 3 },
    ];

    if (isInstitutionalLandlord) {
      return [
        { label: "Property", key: 0 },
        { label: "Parkings", key: 1 },
        { label: "Payment Plans", key: 2 },
        { label: "Update Approved Rent", key: 3 },
      ];
    }

    return baseItems;
  } catch (error) {
    console.error("Failed to parse user data from localStorage:", error);
    return [];
  }
};

export const listQueryParam: PropertyListQueryParams = {
  searchBy: "buildingName",
  searchValue: "",
  sortby: "",
  sort: "",
  page: 1,
  limit: 10,
};

export const showOption = [
  {
    value: "All",
    label: "All Properties",
  },
];
